import { render, staticRenderFns } from "./regAgreement.vue?vue&type=template&id=caec141e&scoped=true"
import script from "./regAgreement.vue?vue&type=script&lang=js"
export * from "./regAgreement.vue?vue&type=script&lang=js"
import style0 from "./regAgreement.vue?vue&type=style&index=0&id=caec141e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caec141e",
  null
  
)

export default component.exports